import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import "../CSS/product.css";
import Navbar from "../COMPONENT/Navbar/Navbar";
import Footer from "../COMPONENT/Footer/Footer";
import Loader from "../COMPONENT/Loader";
import Notfound from "./NotFound";
import { useDispatch } from "react-redux";
import { setProducts, setURL } from "../store/storeDataSlice";
import { setCart } from '../store/cartSlice';

import p1 from "../Images/default.png";

function Product() {
  const { name, product_name, id } = useParams();
  const [loading, setLoading] = useState(false);
  const [isLinkExist, setIsLinkExist] = useState(false);
  const [data, setData] = useState("");
  const dispatch = useDispatch();
 
  

  useEffect(() => {

    const handleCheck = (data) => {
      const productExists = data.products.find(
        (product) => product._id === id && product.productName === product_name
      );
      setIsLinkExist(productExists);
      setData(productExists ? productExists : "");
    };


    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_BACKEND_API}/get-store`,
          { businessLink: name }
        );
        setLoading(false);
        if (response.data.message === "Invalid URL") {
          setIsLinkExist(false);
        } else if (response.data.message === "Valid URL") {
          setIsLinkExist(true);
          dispatch(setProducts(response.data.data));
          dispatch(setURL(name));
          handleCheck(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData(); 
  }, [name, dispatch,id,product_name]);


  const [images, setImages] = useState([]);
  useEffect(() => {
    if (data) {
      setImages(data.images || []);
    }
  }, [data]);

  const [selectedImage, setSelectedImage] = useState();
  useEffect(() => {
    if (data && images.length > 0) {
      setSelectedImage(images[0]);
    }
  }, [images,data]);

  const changeImage = image => {
    setSelectedImage(image);
  };

  const handleAdd = (item) => {
    let cart = JSON.parse(localStorage.getItem(name));
  
    if (!cart) { 
      cart = [];
    }
  
    const existingItem = cart.find((cartItem) => cartItem._id === item._id);
  
    if (existingItem) {
      alert("This item is already in your cart.");
    } else {
      cart.push(item);
      localStorage.setItem(name, JSON.stringify(cart));
      alert("Item added to your cart.");
      dispatch(setCart(JSON.parse(localStorage.getItem(name))));
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {isLinkExist ? (
            <>
              <Navbar />
              <div className="product-container">
                <div className="product-images">
                  {data && images.length > 0 ? (
                    <>
                      <img
                        id="main-image"
                        src={`${process.env.REACT_APP_PRODUCT_IMAGE_PATH}${selectedImage}`}
                        alt="Product"
                      />
                      <div className="thumbnail-images">
                        {images.map((imageSrc, index) => (
                          <img
                            key={index}
                            className="thumbnail"
                            src={`${process.env.REACT_APP_PRODUCT_IMAGE_PATH}${imageSrc}`}
                            alt={`Thumbnail ${index + 1}`}
                            onClick={() => changeImage(imageSrc)}
                          />
                        ))}
                      </div>
                    </>
                  ) : (
                    <img id="main-image" src={p1} alt="Product" />
                  )}
                </div>
                <div className="product-details">
                  <div className="details-content">
                    <h1>{data.productName}</h1>
                    <p>Category: {data.category}</p>
                    <p className="description">{data.productDescription}</p>
                    <p className="price">Selling Price: ₹{data.sellingPrice}</p>
                    <p className="mrp-price">MRP Price: ₹{data.MRP}</p>
                    <p className="discount">
                      Discount:{" "}
                      {(
                        ((data.MRP - data.sellingPrice) / data.MRP) *
                        100
                      ).toFixed(2)}
                      % Off
                    </p>
                    {data.additionalAttributes.length>0 && (
                      <div className="additional-attributes">
                        <h2>Additional Details</h2>
                        {data.additionalAttributes.map((attribute, index) => (
                          <ul key={index}>
                            <li>
                              <span className="attribute-title">
                                {attribute.title}:
                              </span>{" "}
                              {attribute.value}
                            </li>
                          </ul>
                        ))}
                      </div>
                    )}
                    <button className="button-36" onClick={() => handleAdd(data)}>Add to cart</button>
                  </div>
                </div>
              </div>
              <Footer />
            </>
          ) : (
            <Notfound />
          )}
        </>
      )}
    </>
  );
}

export default Product;
